import { Suspense } from "react";
import { LoadingSpinner } from "@/components/atoms/LoadingSpinner";

interface SuspenseWrapperProps {
  children: React.ReactNode;
}

export const SuspenseWrapper = ({ children }: SuspenseWrapperProps) => {
  return <Suspense fallback={<LoadingSpinner />}>{children}</Suspense>;
};
